// extracted by mini-css-extract-plugin
export var abstractObsession = "styles-module--abstractObsession--sMLNy";
export var headerContainer = "styles-module--headerContainer--x7nPJ";
export var abstractObsessionGallery = "styles-module--abstractObsessionGallery--4QZ8F";
export var abstractObsessionRow = "styles-module--abstractObsessionRow--AKQJ5";